module.exports = __webpack_public_path__ + "img/tf1.8e04a26.png";